import { isError } from '@/component/common/error';
import { SearchConditionsParams, useSearchCondition } from '@/component/FilterCommon/hooks/useSearchCondition';
import {
  serviceSearchConditions,
} from '../services/common/filter';
import { isErrorPc } from '@/component/PageComponent/errorPc';


export const useSearchConditionPc = <T extends SearchConditionsParams>(conditionParams: T,options?:{
  manual?: boolean,
},) => {
  const { manual } = options || {}
  return useSearchCondition(conditionParams,{serviceSearchConditions:serviceSearchConditions,manual:manual,isError:isErrorPc})
}
